<p-dialog
  (onHide)="shareClosed.emit()"
  *ngIf="showShareBusinessDialog"
  [visible]="showShareBusinessDialog"
  (visibleChange)="onFlag('showShareBusinessDialog', $event)"
  [blockScroll]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [header]="shareTitle"
  [modal]="true"
  [baseZIndex]="4000"
  maskStyleClass="share-business-dialog-mask"
  [position]="isMobile ? 'bottom' : 'center'"
  [style]="{
    minWidth: isMobile ? '100%' : '370px',
    maxWidth: isMobile ? '100%' : '500px',
    height: !isEmbedded && isMobile && !isPortraitMode ? '100dvh' : 'unset'
  }"
  [ngClass]="{ 'dialog-p-0 dialog-m-0 dialog-bottom': isMobile }"
  class="dialog p-0 z-100"
  styleClass="share-business-dialog"
  appendTo="body">
  <app-share-business
    [businessId]="currentPitchCard?.id"
    [businessType]="currentPitchCard?.businessType"
    [includeReferralInstructions]="
      currentPitchCard?.includeReferralInstructions
    "
    [inputStatus]="currentPitchCard?.businessStatus"
    [introTextOptions]="{
      introText: currentPitchCard?.introText ? currentPitchCard.introText : '',
      referralRequestMessage: currentPitchCard?.referralRequestMessage,
      includeReferralInstructions:
        currentPitchCard?.includeReferralInstructions,
      extraPhoneNumber:
        currentPitchCard?.extraPhone?.nationalNumber ||
        currentPitchCard.contactPhone?.nationalNumber ||
        currentPitchCard?.extraPhoneNumber ||
        currentPitchCard?.contactNumber,
      isEnabledIntroText: currentPitchCard?.isEnabledIntroText,
      name: currentPitchCard?.name
        ? currentPitchCard.name
        : currentPitchCard?.name
          ? currentPitchCard.name
          : currentPitchCard?.displayName
            ? currentPitchCard.displayName
            : '',
      companyName: currentPitchCard?.businessName
        ? currentPitchCard?.businessName
        : currentPitchCard?.title
          ? currentPitchCard.title
          : '',
      preferredIntroMethod: currentPitchCard?.preferredIntroMethod,
      email: currentPitchCard?.email
    }"
    [is3WaySharingDisabled]="!currentPitchCard?.isEnabledIntroText"
    [isOwner]="currentPitchCard?.isOwner"
    [referralRequestMessage]="currentPitchCard?.referralRequestMessage"
    [shareUrl]="shareBusinessUrl">
  </app-share-business>
</p-dialog>
